import {ACCESS_TOKEN_LS_KEY, apiRequest} from '../../../shared/utils/api-request.helper.ts';
import {LoginUserType} from '@wp-content-publisher/typings-lib';
import {
    clearLocalStorage,
    getLocalStorage,
    setLocalStorage
} from '../../../shared/utils/localstorage.util.ts';


export const login = async (data: LoginUserType, controller?: AbortController): Promise<{ access_token: string }> => {
    const result = await apiRequest({
        url: `/auth/login`,
        options: {method: 'POST'},
        data,
        controller
    });
    if (result?.access_token) {
        setLocalStorage(ACCESS_TOKEN_LS_KEY, result?.access_token);
    }
    return result;
}

export const logOut = async () => {
    const result = await apiRequest({url: `/auth/logout`});
    clearLocalStorage();
    console.log(ACCESS_TOKEN_LS_KEY, getLocalStorage(ACCESS_TOKEN_LS_KEY))
    // TODO удалить секрет от паролей сайтов
    return result;
}